// Zenna — waitlist popup
// Shows once per visitor after a short delay, on the homepage only.
// Submits to Shopify's native customer form (creates a subscribed customer,
// no app required) then swaps to a thank-you state.
document.addEventListener('DOMContentLoaded', function () {
  if (localStorage.getItem('zenna_waitlist_seen')) return;

  // Swap this for an image already uploaded to your theme's Files
  // (Content > Files in admin), or any hosted photo URL.
  var IMAGE_URL = 'https://cdn.shopify.com/s/files/1/placeholder/zenna-waitlist.jpg';

  var overlay = document.createElement('div');
  overlay.id = 'zenna-waitlist';
  overlay.innerHTML =
    '<div class="zw-scrim"></div>' +
    '<div class="zw-panel" role="dialog" aria-modal="true" aria-label="Join the waitlist">' +
      '<button class="zw-close" aria-label="Close">&times;</button>' +
      '<div class="zw-media"><img src="' + IMAGE_URL + '" alt=""></div>' +
      '<div class="zw-body">' +
      '<p class="zw-eyebrow">Launching soon</p>' +
      '<h2 class="zw-heading">Be first to shop the edit</h2>' +
      '<p class="zw-prose">Join the list for early access and one email when we open.</p>' +
      '<form class="zw-form" action="/contact#zenna-waitlist" method="post">' +
        '<input type="hidden" name="form_type" value="customer">' +
        '<input type="hidden" name="utf8" value="&#10003;">' +
        '<input type="hidden" name="contact[tags]" value="waitlist">' +
        '<input class="zw-input" type="email" name="contact[email]" placeholder="Email address" required>' +
        '<button class="zw-submit" type="submit">Join the waitlist</button>' +
      '</form>' +
      '<p class="zw-thanks" hidden>You\u2019re on the list. We\u2019ll be in touch.</p>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);

  var style = document.createElement('style');
  style.textContent =
    '#zenna-waitlist{position:fixed;inset:0;z-index:100;display:flex;align-items:center;justify-content:center;opacity:0;visibility:hidden;transition:opacity 240ms cubic-bezier(.4,0,.2,1);}' +
    '#zenna-waitlist.zw-open{opacity:1;visibility:visible;}' +
    '#zenna-waitlist .zw-scrim{position:absolute;inset:0;background:rgba(47,65,42,.44);backdrop-filter:blur(2px);}' +
    '#zenna-waitlist .zw-panel{position:relative;width:min(760px,calc(100vw - 48px));display:grid;grid-template-columns:1fr 1fr;background:#FBF9F6;box-shadow:inset 0 0 0 1px #DCD3C6;border-radius:4px;overflow:hidden;text-align:left;}' +
    '#zenna-waitlist .zw-media{position:relative;background:#E6DDD2;}' +
    '#zenna-waitlist .zw-media img{width:100%;height:100%;object-fit:cover;display:block;}' +
    '#zenna-waitlist .zw-body{padding:44px 40px;text-align:left;}' +
    '#zenna-waitlist .zw-close{position:absolute;top:14px;right:14px;width:28px;height:28px;border:none;background:none;font-size:20px;line-height:1;color:#8A8578;cursor:pointer;font-family:Jost,sans-serif;z-index:2;}' +
    '#zenna-waitlist .zw-eyebrow{margin:0 0 12px;font-family:Jost,sans-serif;font-size:11px;font-weight:500;letter-spacing:.24em;text-transform:uppercase;color:#9B7861;}' +
    '#zenna-waitlist .zw-heading{margin:0 0 12px;font-family:Jost,sans-serif;font-size:26px;font-weight:300;line-height:1.14;color:#25231F;}' +
    '#zenna-waitlist .zw-prose{margin:0 0 24px;font-family:"Cormorant Garamond",Georgia,serif;font-size:17px;line-height:1.5;color:#3D3A34;}' +
    '#zenna-waitlist .zw-form{display:flex;flex-direction:column;gap:10px;}' +
    '#zenna-waitlist .zw-input{width:100%;padding:13px 14px;border:1px solid #DCD3C6;border-radius:2px;font-family:Jost,sans-serif;font-size:14px;background:#fff;color:#25231F;box-sizing:border-box;}' +
    '#zenna-waitlist .zw-input:focus{outline:3px solid #2F412A;outline-offset:2px;}' +
    '#zenna-waitlist .zw-submit{padding:14px;border:1px solid #2F412A;background:#2F412A;color:#F3EDE7;font-family:Jost,sans-serif;font-size:11px;font-weight:500;letter-spacing:.16em;text-transform:uppercase;cursor:pointer;transition:background-color 160ms cubic-bezier(.4,0,.2,1);}' +
    '#zenna-waitlist .zw-submit:hover{background:#25331F;}' +
    '@media (max-width:640px){#zenna-waitlist .zw-panel{grid-template-columns:1fr;}#zenna-waitlist .zw-media{display:none;}}';
  document.head.appendChild(style);

  function open() {
    overlay.classList.add('zw-open');
    localStorage.setItem('zenna_waitlist_seen', '1');
  }
  function close() {
    overlay.classList.remove('zw-open');
  }

  setTimeout(open, 4000);
  overlay.querySelector('.zw-close').addEventListener('click', close);
  overlay.querySelector('.zw-scrim').addEventListener('click', close);

  overlay.querySelector('.zw-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var form = e.target;
    var data = new FormData(form);
    fetch('/contact', { method: 'POST', body: data }).finally(function () {
      form.hidden = true;
      overlay.querySelector('.zw-thanks').hidden = false;
    });
  });
});